<button class="rounded-[4px]  transform transition duration-200"
        [ngClass]="{
        'pt-[15px] pb-[15px] pl-[80px] pr-[80px] f18': size === 'regular',
        'pt-[7px] pb-[7px] pl-[40px] pr-[40px] ': size === 'small',
        'pt-[4px] pb-[4px] pl-[20px] pr-[20px] small': size === 'tiny',
        'text-color-white': type === 'primary-blue-1' || type === 'primary-blue-2' || type === 'primary-blue-3' || type === 'primary-magenta' || type === 'otp-light-green' || type === 'otp-dark-green' || type === 'ephzhb-blue',
        'text-color-sun-yellow': type === 'primary-yellow' || type === 'secondary-yellow',
        'bg-white inset-box': type === 'secondary-blue' || type === 'secondary-yellow' || type === 'secondary-magenta',
        'bg-blue1': type === 'primary-blue-1',
        'bg-blue2': type === 'primary-blue-2',
        'bg-blue3': type === 'primary-blue-3',
        'bg-yellow2': type === 'primary-yellow',
        'bg-magenta': type === 'primary-magenta',
        'bg-otp-light-green': type === 'otp-light-green',
        'bg-otp-dark-green': type === 'otp-dark-green',
        'bg-ephzhb-blue': type === 'ephzhb-blue',
        'bg-ephzhb-yellow': type === 'ephzhb-yellow',
        'text-color-blue2 border-blue2': type === 'secondary-blue',
        'border-sun-yellow': type === 'secondary-yellow',
        'text-color-magenta border-magenta': type === 'secondary-magenta',
        'grayscale': disabled,
        'font-bold': bold
        }"
        [style.width.px]="width"
        [disabled]="disabled"
        (click)="buttonClicked.emit()"
        type="button">
  <ng-content></ng-content>
  {{label}}
</button>
